import { Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { fromEvent, map, startWith } from 'rxjs';


export const MediaQuery = {

	/**
	 * Creates a Signal that listens for a media query.  This
	 * is _much_ more efficient than listening to resize events.
	 * 
	 * This function calls toSignal() so it _must_ be called
	 * within an injection context (constructor).
	 * 
	 * @param query - A valid media query.  e.g. '(max-width: 768px)'
	 */
	createSignal(query: string): Signal<boolean> {

		//
		// Use the matchMedia API to monitor whether the document matches the query.
		//
		const mediaQuery = window.matchMedia(query);

		//
		// Observe the mediaQuery change event, and start with the current value.
		//
		const mediaObservable$ = fromEvent<MediaQueryListEvent>(mediaQuery, 'change').pipe(
			map(event => event.matches),
			startWith(mediaQuery.matches),
		);

		//
		// Create a signal, initialize with the whether the query currently matches.
		//
		return toSignal(mediaObservable$, { initialValue: mediaQuery.matches });

	}
};